import { HTTP_STATUS } from './http';
export class ApiError extends Error {
    response;
    body;
    constructor(message, response, body) {
        super(message);
        this.name = 'ApiError';
        this.response = response;
        this.body = body;
    }
    get statusCode() {
        return this.response.status;
    }
    /**
     * If the HTTP response body is JSON matching the shape:
     *   { error_name: string; message: string }
     * then these getters expose those fields; otherwise they return undefined.
     */
    get responseErrorName() {
        if (typeof this.errorData?.error_name === 'string') {
            return this.errorData.error_name;
        }
        return undefined;
    }
    /**
     * If the HTTP response body is JSON matching the shape:
     *   { error_name: string; message: string }
     * then these getters expose those fields; otherwise they return undefined.
     */
    get responseErrorMessage() {
        if (typeof this.errorData?.message === 'string') {
            return this.errorData.message;
        }
        return undefined;
    }
    get errorData() {
        if (this.body && typeof this.body === 'object') {
            return this.body;
        }
        return undefined;
    }
}
export class ForbiddenError extends ApiError {
    constructor(message, response, body) {
        super(message, response, body);
        this.name = 'ForbiddenError';
    }
}
export class UnauthorizedError extends ApiError {
    constructor(message, response, body) {
        super(message, response, body);
        this.name = 'Unauthorized';
    }
}
const errorByStatus = {
    [HTTP_STATUS.Forbidden]: ForbiddenError,
    [HTTP_STATUS.Unauthorized]: UnauthorizedError,
};
export function createApiError(message, response, body) {
    const ErrorClass = errorByStatus[response.status] ?? ApiError;
    return new ErrorClass(message, response, body);
}
/**
 * Given a non-OK Response, parse its JSON body (if any)
 * and return a fully‑formed ApiError.
 */
export async function parseApiError(response, url) {
    let responseData;
    const contentType = response.headers.get('Content-Type') || '';
    if (contentType.includes('application/json')) {
        // swallow any parse error and leave body undefined
        responseData = await response.json().catch(() => undefined);
    }
    const message = createErrorMessage(responseData, response.status, url);
    return createApiError(message, response, responseData);
}
export function createErrorMessage(responseData, status, url) {
    const apiMessage = responseData?.message || 'No message attribute in JSON';
    return `Valuation API responded with ${status} at ${url} - ${apiMessage}`;
}
